import { FC } from 'react'

import { useI18n } from '../../hooks'
import { Uuid } from '../../types'
import CategoryCardOverlay from './categoryCardOverlay'

export type CategoryProp = {
  title: string
  url: string
  image: {
    url: string
    alt: string
  }
  productCategory: Uuid
}

export type Prop = {
  className: string
}

const CategoryCard: FC<CategoryProp & Prop> = ({ title, url, image, className, productCategory }) => {
  const { t } = useI18n()
  const handleTitle = (title: string): string =>
    (title || '').replace(', ', ',\n').replace(` ${t('Common_ampersand')} `, `\n${t('Common_ampersand')}\n`)
  return (
    <div className={'categoryCard ' + className} id={productCategory}>
      <CategoryCardOverlay title={handleTitle(title)} url={url} value="View Products">
        <img
          className={'categoryCard-image'}
          src={image.url}
          alt={`${image.alt} ${t('Common_Category')}`}
          aria-label={`${image.alt} ${t('Common_Category')}`}
        />
      </CategoryCardOverlay>
    </div>
  )
}

export default CategoryCard
